import React, { Component } from "react";
import "./Wishlist.css";
import { Helmet } from "react-helmet";
import NewHeader from "../NewHeader/NewHeader";
import EmptyImage from "../../assets/images/Empty.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEuroSign, faCartShopping, faTrash } from "@fortawesome/free-solid-svg-icons";
import Modal from "react-modal";
import { getwishlistCartData, getAgentCommissionDetails, getCustomerLogin, WishlistDelete } from "../axios";
import Skeleton from "react-loading-skeleton";
import moment from "moment";
import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";
import { PDFDownloadLink } from "@react-pdf/renderer";
import InvoiceAgent from "./InvoiceAgent/Invoice";
import { QueryClient, QueryClientProvider, useQuery } from "react-query";

import { connect, Provider } from "react-redux";
import { createStore } from "redux";
import {
  addToCart,
  clearToCart,
  updateToCart,
} from "../../redux/actions/actions";

const styleH1 = {
  fontSize: "15px",
  textAlign: "center",
  color: "red",
};

const invisibleStyle = {};

const queryClient = new QueryClient();
const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    backgroundColor: "#E4E4E4",
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
});


class Wishlist extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Agent: true,
      ChangeColor: "reviewPlanned",
      ChangeColorNew: "tripStatusContainer reviewPlannedNew",
      agentData: null,
      wishlistData: null,
      Commission: null,
      CustomerDetails: null,
      openModal:false,
      currentItemId:null,
      planDetails:null
      //Scrollview: "infiniteScroll",
    };
  }

  componentDidMount() {
    this.setState({ Agent: true });
    this.setState({ ChangeColor: "reviewUpcoming" });
    this.setState({ ChangeColorNew: "tripStatusContainer reviewUpcomingNew" });

    const userArr = localStorage.getItem("userDetails");
    const userArrNew = JSON.parse(userArr);
    const customer_id = userArrNew?.agent_id;
    const email_id = userArrNew.email;

  
       getCustomerLogin(email_id).then(
         (data) => {
          // console.log(data);
           this.setState({ CustomerDetails: data?.agent });
         },
         (error) => {}
       );
     

    getwishlistCartData(customer_id).then(
      (data) => {
    
        this.setState({ wishlistData: data });
      },
      (error) => {}
    );
    
    getAgentCommissionDetails(customer_id).then(
      (data) => {
        if (data != "") {
          this.setState({ Commission: data });
        }
      },
      (error) => {}
    );

  

  }

  handleClickWishlist = (
    itemID, plandetails
  ) => {
    if(this.props.showcart.cardItems.cardData.length >0){

        this.setState({ currentItemId: itemID });
        this.setState({ planDetails: plandetails });
        this.setState({ openModal: true });
    }else{
      
      this.props.clearToCart();
      var plandetailsNew =  JSON.parse(plandetails);
      plandetailsNew.map((newData, j) => {
    
      this.props.addToCart(newData);
      })

      setTimeout(function () { 
        const url = "/cartview";
        window.location.replace(url);
      },  2000);
    }

  }
  handleRemove = (wishlist_id) => {
    let text =
    "Are you sure you want to delete this item.";
    if (window.confirm(text) == true) {
      WishlistDelete(
        wishlist_id
      ).then(
        (data) => {
          const url = "/mytripplan";
          window.location.replace(url);
        },
        (error) => {}
      );
    }
  };

  processedWithoutSaving = () =>{

    this.props.clearToCart();
    let plandetailsNew =  JSON.parse(this.state.planDetails);
    plandetailsNew&&(Object.entries(plandetailsNew.map((newData, j) => {

    this.props.addToCart(newData);
    })))

    setTimeout(function () { 
      const url = "/cartview";
      window.location.replace(url);
     },  2000);
  }
  goToCartClick = () =>{
      const url = "/cartview";
      window.location.replace(url); 
  }
  closePopupmessage = () =>{
    this.setState({ openModal: false });
  }
  

  render() {
    return (
      <div>
        <Helmet>
          <title> Plan your Best Trip @ Holiday Seychelles</title>
          <meta
            name="description"
            content="Plan your honeymoon in one of the beautiful places in the world - Holiday Seychelles."
          />
          <meta
            name="keywords"
            content="Seychelles, Seychellen, best place for honeymoon,most beautiful places in the world,best honeymoon destination in the world,honeymoon places,honeymoon destinations,beautiful places in the world"
          />
        </Helmet>
        <h1 style={{ color: "#fff" }}>
          {" "}
          Plan your Best Trip @ Holiday Seychelles
        </h1>
        <NewHeader page={"inner_listing"} />
        <div className="TripContainer" id="container">
          <div className={this.state.ChangeColor} style={{ marginTop: "-5px" }}>
            <div className="landingContainer">
              <h4>My Trip Plan</h4>
            </div>
          </div>

          <div className={this.state.ChangeColorNew}>
            <div className="tripStatusWrap">
              <ul>
                <li
                  className={this.state.Agent && "active ColorUpcoming"}
                  onClick={this.WishlistChange}
                >
                  <a className="mytripmakeFlex">
                    <span className="cm__myTripSprt--tabUpcoming cm__myTripSprt appendRight10"></span>
                    <span className="tripStatusWrap__statusText">
                      <span className="font16 latoBlack capText">
                       My Trip Plan
                      </span>
                      <span className="font12 latoBold"></span>
                    </span>
                  </a>
                </li>
              </ul>
              <div className="txtFild "></div>
            </div>
          </div>
          <div className="contentWrapper myTrips">
            <div style={{"height": "100%"}}>
              <div className="tripListingWrap">
                <div>
                  {this.state.Agent == true ? (
                    <div className="myTripLstngLobCrd forUpcoming">
                      {this.state.wishlistData == "" ? (
                        <div className="emptyErr">
                          <div className="emptyErr--imgCont">
                            <img src={EmptyImage} alt="Upcoming Image" />
                          </div>
                          <div>
                            <p className="emptyErr--heading font22 latoBlack appendBottom15">
                              Looks empty, you've no Trip Plan's .
                            </p>
                            <p className="emptyErr--subHeading fomt14 darkGreyText appendBottom25">
                              When you save your cart, you will see Plan's here
                              here.
                            </p>
                            <p style={{margin: 10}}>
                              <a href="/home">
                                <button className="font14 latoBold blueText myTripBtn myTripBtn--primary ">
                                  Plan a trip
                                </button>
                              </a>
                            </p>
                          </div>
                        </div>
                      ) : (
                        <>
                          {this.state.wishlistData == null ? (
                            <>
                              <div
                                className="Container-Tile"
                                style={{ height: 250 }}
                              >
                                <div className="ContainerFlex">
                                  <div
                                    className="ContainerImage"
                                    style={{ padding: "15px 10px 10px 10px" }}
                                  >
                                    <Skeleton
                                      style={{ width: "100%", height: "165px" }}
                                    />
                                  </div>
                                  <div
                                    className="ContainerContent"
                                    style={{ padding: "10px 10px 10px 40px" }}
                                  >
                                    <div
                                      className="nameContainer"
                                      style={{ width: "100%" }}
                                    >
                                      <div className="paymakeFlex appendBottom5">
                                        <h3 className="latoBlack font22 blackText">
                                          <Skeleton
                                            style={{ width: "200px" }}
                                          />
                                        </h3>
                                        <span
                                          className="sRating"
                                          style={{
                                            display: "inline-flex",
                                            marginTop: "5px",
                                            marginLeft: "10px",
                                          }}
                                        >
                                          <Skeleton
                                            style={{ width: "100px" }}
                                          />
                                        </span>
                                      </div>
                                      <p>
                                        <Skeleton style={{ width: "300px" }} />
                                      </p>
                                      <h3
                                        className="latoBlack font22 blackText"
                                        style={{
                                          marginTop: 10,
                                          fontSize: 18,
                                          fontWeight: "bold",
                                        }}
                                      >
                                        <Skeleton style={{ width: "150px" }} />
                                      </h3>

                                      <div class="chkContBooking">
                                        <div class="chkCont__col">
                                          <div class="paymakeFlex column">
                                            <span class="font10 grayText appendBottom3">
                                              <Skeleton
                                                style={{ width: 150 }}
                                              />
                                            </span>
                                            <span class="latoBlack font24 blackText appendBottom3">
                                              <Skeleton
                                                style={{ width: 150 }}
                                              />
                                            </span>
                                            <span class="font10 grayText 444">
                                              <Skeleton
                                                style={{ width: 150 }}
                                              />
                                            </span>
                                          </div>
                                          <div class="chkCont__night">
                                            <span>
                                              <Skeleton
                                                style={{ width: 150 }}
                                              />
                                            </span>
                                          </div>
                                          <div class="paymakeFlex column">
                                            <span class="font10 grayText appendBottom3">
                                              <Skeleton
                                                style={{ width: 150 }}
                                              />
                                            </span>
                                            <span class="latoBlack font24 blackText appendBottom3">
                                              <Skeleton
                                                style={{ width: 150 }}
                                              />
                                            </span>
                                            <span class="font10 grayText">
                                              <Skeleton
                                                style={{ width: 150 }}
                                              />
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="Container-Tile">
                                <div className="ContainerFlex">
                                  <div class="container">
                                    <div class="row">
                                      <div
                                        style={{
                                          //height: "180px",
                                          overflowY: "auto",
                                        }}
                                      >
                                        <table className="table table-bordered">
                                          <thead className="thead-dark">
                                            <tr>
                                              <th scope="col">#</th>
                                              {/* <th scope="col">
                                                                Reference ID 
                                                                </th> */}
                                              <th scope="col">Plan Name</th>
                                              <th scope="col">
                                                Quotation Form
                                              </th>
                                              <th scope="col">Created Date</th>
                                              <th scope="col">Action</th>
                                            </tr>
                                          </thead>

                                          <tbody>
                                            {this.state.CustomerDetails && this.state.wishlistData &&
                                              this.state.wishlistData.map(
                                                (item, newindex) => {
                                                const newIteam= JSON.parse(item.plan_details);
                                                  const TotalPrice = newIteam.reduce(
                                                    (amount, newdata) => parseFloat(newdata.totalamountincluded) + amount,
                                                    0
                                                  );
                                              
                                                  const TotalPriceAll = newIteam.reduce(
                                                    (amount, newdata) => parseFloat(newdata.totalAmount) + amount,
                                                    0
                                                  );
                                                 
                                              
                                                  const TaxandFee = 0;
                                                  let TotalPriceInclude = TaxandFee + TotalPrice;
                                                  let CommissionPrice = (parseFloat(this.state.Commission) / 100) * TotalPriceInclude;
                                                  let FinalPrice = parseFloat(TotalPriceInclude - CommissionPrice);
                                                  let OfferPrice = (TotalPriceAll-TotalPriceInclude);
                                                  let JsonStatePDFAcco = {
                                                    booking_amount: TotalPriceInclude,
                                                    total_main_amount:TotalPriceAll,
                                                     offer_discount: OfferPrice,
                                                    numberof_night: 2,
                                                    agentdetails: this.state.CustomerDetails,
                                                    child: newIteam,
                                                  };
                                                  const propertypdf = JSON.stringify(
                                                    JsonStatePDFAcco
                                                  );
                                                 
                                                  return (
                                                    <>
                                                      <tr>
                                                        <th scope="row">
                                                          {newindex + 1}
                                                        </th>

                                                        <td>
                                                          {item.plan_name}
                                                        </td>
                                                        <td>
                                                        {
                                                            <PDFDownloadLink
                                                              document={
                                                                <InvoiceAgent
                                                                invoice={
                                                                  propertypdf
                                                                }
                                                                />
                                                              }
                                                              fileName="Quotation.pdf"
                                                              style={{
                                                                fontSize:
                                                                  "15px",
                                                                color:
                                                                  "#ff0000",
                                                                fontWeight:
                                                                  "400",
                                                              }}
                                                            >
                                                              {({
                                                                blob,
                                                                url,
                                                                loading,
                                                                error,
                                                              }) =>
                                                                loading
                                                                  ? "Loading document..."
                                                                  : "Download Quotation"
                                                              }
                                                            </PDFDownloadLink>
                                                          }
                                                        </td>
                                                        <td>
                                                          {moment(
                                                            item.created_date
                                                          ).format("D MMM Y")}
                                                        </td>
                                                        <td> 
                                                        <FontAwesomeIcon
                                                          icon={faTrash}
                                                          style={{
                                                            fontSize: "14px",
                                                            marginRight: "5px",
                                                            cursor: "pointer",
                                                            marginTop: "10px",
                                                          }}
                                                          onClick={() => {
                                                            this.handleRemove(item?.id)}}
                                                        ></FontAwesomeIcon>
                                                          <button
                                                           onClick={() => {
                                                            this.handleClickWishlist(item?.id, item.plan_details)}}
                                                          class="btn btn-outline-danger"
                                                          style={{lineHeight: '15px' }}
                                                        >
                                                          Open To Cart
                                                        </button></td>
                                                      </tr>
                                                    </>
                                                  );
                                                }
                                              )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        </>
                      )}
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal
        className="Modal"
        ariaHideApp={false}
        overlayClassName="backdrop"
        isOpen={this.state.openModal}
     
        onRequestClose={this.state.closeModal}
      >
        <div className="modalCont">
          <span className="closeButton" onClick={() => {this.closePopupmessage()}}>
            Close
          </span>
          
          <div className="modalContent">
            <div>
              <div className="latoRegular font16 appendBottom15">
                <h5>This will come in case of there are items in the cart </h5>
              </div>
            </div>
            <div>
            <div className="latoRegular font16 appendBottom15">
                <div className="width">
                        <p className="font16 appendBottom10 guestDtlsTextLbl">
                          <span className="capText"></span>
                          You already have items in your cart. would you like to save the same or processed further without saving it?
                        </p>
                      
                    </div>
              </div>
            </div>
            <div>
              
              <div className="latoRegular font16 appendBottom15">
              
                <button
                onClick={() => {
                  this.processedWithoutSaving()}}
                  class="btn btn-success float-right" style={{float: 'right', marginLeft: '10px'}}
                >Processed Without Saving
                </button>
                <button  onClick={() => {
                    this.goToCartClick()}} class="btn btn-warning float-right" style={{float: 'right'}}>
                  Go To Cart
                </button>
               
              </div>
            </div>
          </div>
        </div>
      </Modal>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addToCart: (item) => {
      dispatch(addToCart(item));
    },
    updateToCart: (item) => {
      dispatch(updateToCart(item));
    },
    clearToCart: (item) => {
      dispatch(clearToCart(item));
    },
  };
};

const mapStateToProps = (state, ownProps = {}) => {
  return {
    showcart: state,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Wishlist);
//export default Wishlist;
